import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "Curation",
    body: "Every formula is hand-selected from brands we trust — nothing enters the collection without earning its place.",
  },
  {
    n: "02",
    title: "Authenticity",
    body: "Sourced directly from the brands themselves. No imitations, no grey market — only the genuine article.",
  },
  {
    n: "03",
    title: "Craft",
    body: "Herbal wisdom, salon science and modern grooming — united under one roof, held to one standard.",
  },
];

export const Manifesto = () => (
  <section id="manifesto" className="py-32 md:py-40 border-t border-zinc-200 bg-zinc-50" data-testid="manifesto-section">
    <div className="max-w-[1600px] mx-auto px-6 md:px-12">
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="text-xs uppercase tracking-[0.5em] text-gold mb-20"
      >
        The Manifesto
      </motion.p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-12">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.n}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.15 }}
            className="border-t border-gold/30 pt-8"
            data-testid={`manifesto-chapter-${c.n}`}
          >
            <span className="font-serif italic text-5xl text-gold/60">{c.n}</span>
            <h3 className="font-serif font-medium text-3xl text-zinc-900 mt-6">{c.title}</h3>
            <p className="text-zinc-500 leading-relaxed mt-4 text-sm">{c.body}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
